import { render } from "./InputGroup.vue?vue&type=template&id=d5ff8216&scoped=true"
import script from "./InputGroup.vue?vue&type=script&lang=ts"
export * from "./InputGroup.vue?vue&type=script&lang=ts"

import "./InputGroup.vue?vue&type=style&index=0&id=d5ff8216&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d5ff8216"

export default script